module.exports = __webpack_public_path__ + "img/64.1fc28b65.png";